import { Component, OnInit, Input, Output, EventEmitter, ElementRef} from '@angular/core';

@Component({
  selector: 'lib-ctl-confirm-modal',
  templateUrl: './ctl-confirm-modal.component.html',
  styleUrls: ['./ctl-confirm-modal.component.css']
})
export class CtlConfirmModalComponent implements OnInit {
  @Input() modalID: any;
  @Input() titleMessage: string;
  @Input() subTitleMessage: string;
  @Input() detailMessage: string;
  @Input() listMessage:any;
  @Input() listMessage1:any;
  @Input() detailMessageLine1: string;


  @Output() confirm: EventEmitter<object> = new EventEmitter();
  textDir:any;
  constructor(private el: ElementRef) {
    this.textDir =  sessionStorage.getItem('textDir');
   }

  ngOnInit(): void {
    
  }

  confirmed() {
    this.confirm.emit();
  }
  
}
